app.service("browserDetector", [
	"$window",
	function ($window) {
		// A UA that names the browser without the version token (Chrome on iOS reports "CriOS/" and no
		// "Version/", so it lands in the Safari branch) made match() return null and [1] throw, which
		// broke ExceptionAPI's upload for exactly the errors it was reporting.
		function versionFrom(userAgent, pattern) {
			var match = userAgent.match(pattern);
			return match ? match[1] : "Unknown";
		}

		return {
			getBrowserInfo: function () {
				var userAgent = $window.navigator.userAgent;
				var url = $window.location.href;
				var browserName = "Unknown";
				var browserVersion = "Unknown";

				// Example parsing for common browsers
				if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edge") === -1) {
					browserName = "Chrome";
					browserVersion = versionFrom(userAgent, /Chrome\/(\d+)/);
				} else if (userAgent.indexOf("Firefox") > -1) {
					browserName = "Firefox";
					browserVersion = versionFrom(userAgent, /Firefox\/(\d+)/);
				} else if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1) {
					browserName = "Safari";
					browserVersion = versionFrom(userAgent, /Version\/(\d+\.\d+)/);
				} else if (userAgent.indexOf("Edge") > -1) {
					browserName = "Edge";
					browserVersion = versionFrom(userAgent, /Edge\/(\d+\.\d+)/);
				} else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident") > -1) {
					browserName = "Internet Explorer";
					if (userAgent.indexOf("MSIE") > -1) {
						browserVersion = versionFrom(userAgent, /MSIE (\d+\.\d+)/);
					} else {
						// IE 11+
						browserVersion = versionFrom(userAgent, /rv:(\d+\.\d+)/);
					}
				}

				return {
					name: browserName,
					version: browserVersion,
					userAgent: userAgent,
					url
				};
			},
		};
	},
]);
